export default "__VITE_ASSET__a8226773__"